import {Component, DestroyRef, Inject, OnInit, computed, inject, signal} from '@angular/core';
import {takeUntilDestroyed} from "@angular/core/rxjs-interop";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {DialogData} from "../confirm-dialog/confirm-dialog.component";
import {MenuService} from "../../_services/menu-service/menu.service";
import {ShopConfigService} from "../../_services/shop-config/shop-config.service";
import {readCurrentLocaleOnce} from "../locale/current-url";
import {resolveShopUrl} from "../shop-config/shop-url";
import {ORDER_TILE_NAV_NAME, createHomeTiles, withOrderLink} from "../home-tiles/home-tiles";
import {HomeTile} from "../../../_models/home-tile";
import {Router} from "@angular/router";

interface MobileMenuItem {
  navName: string;
  routerLink: string[] | string | null;
  webLink: string;
}

@Component({
    selector: 'app-client-menu',
    templateUrl: './client-menu.component.html',
    styleUrls: ['./client-menu.component.scss'],
    standalone: false
})
export class ClientMenuComponent implements OnInit {

  private readonly shopConfigService = inject(ShopConfigService);
  private readonly destroyRef = inject(DestroyRef);
  // Jezyk z ADRESU — identycznie jak na stronie glownej (patrz home.component.ts).
  private readonly locale = readCurrentLocaleOnce();

  constructor(
    private menuService: MenuService,
    private router: Router,
    public dialogRef: MatDialogRef<ClientMenuComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) { }
  // SYGNAL z tego samego powodu co w HomeComponent: serwerowy bundle jest
  // zoneless, wiec mutacja zwyklego pola w callbacku HTTP nie planuje wykrywania
  // zmian i do HTML-a poszedlby adres poczatkowy. Szczegoly: home.component.ts.
  readonly menu = signal<HomeTile[]>(createHomeTiles());

  // Lista hamburgera na telefonie: te same pozycje i ta sama kolejnosc co
  // kafelki (createHomeTiles), plus aktualnosci na koncu. `computed`, a nie
  // osobna tablica, wiec adres sklepu z bazy trafia tu bez drugiej subskrypcji.
  readonly mobileMenu = computed<MobileMenuItem[]>(() => [
    ...this.menu().map((tile) =>
      tile.navName === ORDER_TILE_NAV_NAME
        ? { navName: tile.navName, routerLink: null, webLink: tile.link as string }
        : { navName: tile.navName, routerLink: tile.routerLink, webLink: '' }
    ),
    { navName: 'common.news', routerLink: ['/news'], webLink: '' },
  ]);


  ngOnInit(): void {
    this.shopConfigService
      .load()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((config) => {
        const href = resolveShopUrl(config, this.locale);
        this.menu.update((tiles) => withOrderLink(tiles, href));
      });
  }

  navigateTo() {
    this.menuService.nextMenuIsOpen(false);
    this.dialogRef.close();
  }

  navigateToNews() {
    this.router.navigate(['/news'])
    this.dialogRef.close();
  }


}
